<h2 i18n>Place new shoe in position and confirm placement</h2>

<div class="change-shoe-anim"></div>
